import React from 'react';
import './index.scss';
import conpInfo_banner from 'static/imgs/conpInfo_banner0609.png';

const ServePromise: React.FC = () => {
  return (
    <div className='comp-info-wrap'>
      <h2 className='title'>公司介绍</h2>
      <div className='header_img'>
        <img src={conpInfo_banner} alt='图片' />
      </div>
      <p className='comp_desc'>
      2022年，公司累计保费收入突破<span className='f_w'>52亿元</span>。目前公司在广东、上海、北京、四川和深圳设有分支机构。2023年4月，国际著名信用评级机构惠誉评级（Fitch Ratings）公告给予京东安联保险<span className='f_w'>“A-”</span> 的保险公司财务实力（IFS）评级，<span className='f_w'>展望稳定</span>。
      </p>
    </div>
  );
};

export default ServePromise;
